import * as React from 'react';
const CountdownTimer = ({ timeRemaining }) => {
    const formatTime = (time) => {
        const formattedDays = time.days.toString().padStart(2, '0');
        const formattedHours = time.hours.toString().padStart(2, '0');
        const formattedMinutes = time.minutes.toString().padStart(2, '0');
        return `${formattedDays} days ${formattedHours} hours ${formattedMinutes} mins`;
    };
    return React.createElement(React.Fragment, null, formatTime(timeRemaining));
};
export default CountdownTimer;
